import React from "react";
import { connect } from "react-redux";
import styled from "styled-components";
import { THEME_HIGH, THEME_MEDIUM, THEME_LOW } from "../../reducers/reader";
import { AppState } from "../../store";

export const COLORS: Record<string, Record<string, string>> = {
    [THEME_HIGH]: {
        color: "#000",
        bgColor: "#fff9c6",
    },
    [THEME_LOW]: {
        color: "#fff",
        bgColor: "#191919",
    },
    [THEME_MEDIUM]: {
        color: "#000",
        bgColor: "#fff",
    },
};

const Container = styled.div<{ theme: string }>`
    position: fixed;
    z-index: 1;
    right: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: ${(p) => COLORS[p.theme]["bgColor"]};
`;

type Props = ReturnType<typeof mapState>;

class BgColor extends React.Component<Props> {
    render() {
        return <Container theme={this.props.theme} />;
    }
}

const mapState = ({ reader }: AppState) => ({
    //@ts-ignore
    theme: reader.get("theme") as string,
});
export default connect(mapState)(BgColor);
